var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "remove-button" },
    [
      _c(
        "el-button",
        {
          attrs: {
            type: "danger",
            size: "mini",
            plain: "",
            icon: "el-icon-delete",
          },
          on: { click: _vm.confirmRemove },
        },
        [_vm._v("移除")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }